export default "__VITE_ASSET__DVNd_4hR__"